import React from "react";
import { TitleinMaindiv } from "../../components/extra";
import { AboutComponent } from "../../components/about/about";

const About = () => {

    return(
        <> 
            <AboutComponent />
        </>
    )
}

export default About;